










import { Vue, Component } from 'vue-property-decorator';
import ContractService from '@/domain/contract/service/contract.service';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import ContractHistoryEntity from '@/domain/contract/entity/contract-version-history.entity';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store'
import EventBus, { Event } from '@/event.bus';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import ContractHistoryTimeline from './contract-history-timeline.component.vue';

@Component({
  components: {
    ContractHistoryTimeline,
  },
})
export default class ContractHistory extends Vue {
  private contractHistory: ContractHistoryEntity = ContractHistoryEntity.of({});

  private businessUnitId: string = '';

  private timelineKey: number = 0;

  created() {
    this.businessUnitId = UserBusinessUnitService.currentBusinessUnit.id;
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      if (this.$route.name && this.$route.name.includes('HistóricoContrato')) {
        this.businessUnitId = businessUnit.id;
        this.fetchContractHistoryInfo();
      }
    });
    this.fetchContractHistoryInfo();
  }

  private fetchContractHistoryInfo(): void {
    if (this.$route.params.id) {
      this.getContractHistory();
    }
  }

  private getContractHistory(): void {
    if (this.businessUnitId) {
      ContractService.getContractHistory(this.businessUnitId, this.$route.params.id)
        .then((response: any) => {
          this.contractHistory = ContractHistoryEntity.of(response);
        })
        .then(() => this.rerenderTimeline())
        .catch((err: any) => VbSnackbarService.handleHttpError(err));
    }
  }

  private rerenderTimeline(): void {
    this.timelineKey += 1;
  }
}
